import React from 'react';

interface HighlightedTextProps {
  text: string;
  searchTerm: string;
  className?: string;
}

/**
 * Escapes special characters in a string for use in a regular expression
 */
export const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};


export const highlightText = (text: string, searchTerm: string): React.ReactNode => {
  if (!searchTerm || typeof text !== 'string') return text;
  
  const searchTermLower = searchTerm.toLowerCase();
  if (!text.toLowerCase().includes(searchTermLower)) return text;
  
  const escapedSearchTerm = escapeRegExp(searchTermLower);
  const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
  const parts = text.split(regex);
  
  return parts.map((part, index) => 
    part.toLowerCase() === searchTermLower 
      ? <span key={index} className="bg-yellow-100/70 text-gray-800 font-medium px-1 py-0.5 rounded inline-block">{part}</span> 
      : part
  );
};

/**
 * Component to highlight search terms within text
 */
export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, searchTerm, className = "" }) => {
  if (!searchTerm || !text) return <span className={className}>{text}</span>;
  
  return (
    <span className={className}>
      {highlightText(text, searchTerm)}
    </span>
  );
};

export default HighlightedText; 